<template>
  <div>
    <div class="d-flex align-center mt-1 mb-4">
      <div class="d-flex"><p class="ma-0 mx-2">지연시간</p></div>
      <div class="flex-grow-1">
        <DelaySlider :cmd="cmd" @change="onChangeDelay"></DelaySlider>
      </div>
    </div>

    <v-chip style="margin: 2px" v-for="(item, i) in items" :key="i" :color="_color(item)" @click="onClickChip(item)"
      >{{ item.label || item.fileName }}
    </v-chip>

    <!-- 내 리소스 (사용자 업로드) -->
    <template v-if="userItems.length">
      <div class="text-caption grey--text mt-3 mb-1">내 리소스</div>
      <v-chip
        style="margin: 2px"
        v-for="item in userItems"
        :key="item.id"
        :color="_colorUser(item)"
        @click="onClickUserChip(item)"
        >{{ item.label || item.file_name }}
      </v-chip>
    </template>
  </div>
</template>

<script>
import BroadCastResourceManager from "@/domain/BroadCastResourceManager/BroadCastResourceManager";
import ResourceUserApi from "@/api/ResourceUserApi";
import DelaySlider from "../-components/DelaySlider.vue";

export default {
  components: { DelaySlider },
  model: {
    prop: "cmd",
    event: "input",
  },
  props: {
    cmd: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      items: [...BroadCastResourceManager.getAudioEffect()],
      userItems: [],
    };
  },
  async created() {
    await BroadCastResourceManager.ensureLoaded();
    this.items = [...BroadCastResourceManager.getAudioEffect()];
    try {
      this.userItems = await ResourceUserApi.list("sound_effect");
    } catch (e) {
      console.warn("[AudioEffectCmd] 내 리소스 로드 실패", e);
    }
  },
  watch: {},
  methods: {
    onClickChip(item) {
      const { fileName } = item;
      const cmd = this.makeSeedCmd();
      cmd.argSchema1 = { targetFileName: fileName };
      this.$emit("input", cmd);
    },
    onClickUserChip(item) {
      const cmd = this.makeSeedCmd();
      cmd.argSchema1 = { targetKey: item.storage_key, targetFileName: item.file_name };
      this.$emit("input", cmd);
    },
    onClickRemove() {},
    onChangeDelay(delay_ms) {
      const cmd = this.makeSeedCmd();
      cmd.delay = delay_ms;
      this.$emit("input", cmd);
    },
    makeSeedCmd() {
      if (!this.cmd) {
        return {
          _type: "AUDIO",
          delay: null,
          targetRef: "audioEffectPlayer",
          argSchema1: { targetFileName: null },
        };
      }

      return JSON.parse(JSON.stringify(this.cmd));
    },
    _color(item) {
      const { fileName } = item;

      if (!this.cmd || !this.cmd.argSchema1) return "grey";

      return this.cmd.argSchema1.targetFileName === fileName && !this.cmd.argSchema1.targetKey ? "primary" : "grey";
    },
    _colorUser(item) {
      if (!this.cmd || !this.cmd.argSchema1) return "grey";
      return this.cmd.argSchema1.targetKey === item.storage_key ? "primary" : "grey";
    },
  },
};
</script>

<style></style>
